var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSquareMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 87,
    viewBox: "0 0 77 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2129 -27L113.117 62.2124L23.9049 86.1168L0.000475724 -3.09561L89.2129 -27ZM76.2929 -4.62188L22.3786 9.82441L36.8249 63.7387L90.7392 49.2924L76.2929 -4.62188Z",
    fill: "#6020D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSquareMobile);
export default __webpack_public_path__ + "static/media/RightSquareMobile.50fa1f052fa0eb569d9254cb452d4cd5.svg";
export { ForwardRef as ReactComponent };